import { GetWallets } from 'shared/data/wallets/v1';

export const filterAvailableCurrencies = (wallet: GetWallets['response']['items'][number]) => {
    return !wallet.isVisible;
};
